import React, { FC } from 'react';
import { Portal } from '../Portal/index';
import styled from 'styled-components';
import { borderColor, fontSemibold } from '../../../themes';
import { PortalContainer } from '../Portal/common';

const LabelDetailsContainer = styled.div`
  padding: 30px;
  text-align: center;
`;

const LabelTitle = styled.p`
  font-family: ${fontSemibold};
`;

const LabelDetailsButtonsContainer = styled(LabelDetailsContainer)`
  border-top: 1px solid ${borderColor};
`;

const LabelCancelButton = styled.div`
  width: 100%;
  padding: 5px;
  border-radius: 5px;
  text-transform: uppercase;
  font-family: ${fontSemibold};
`;

const LabelDetailsWrapper = styled.div`
  border-radius: 12px 12px 0px 0px;
  background-color: #ffffff;
  position: absolute;
  bottom: 0;
  width: 100%;
`;

interface LabelPortalProps {
  show: boolean;
  title: string;
  message: React.ReactNode | string;
  cancelTranslation: string;
  onLabelDismiss: () => void;
}

export const LabelPortal: FC<LabelPortalProps> = ({
  title,
  message,
  show,
  cancelTranslation,
  onLabelDismiss,
}) => (
  <Portal
    id="display-label"
    content={
      <PortalContainer backgroundColor="#112530" show={show}>
        <LabelDetailsWrapper>
          <LabelDetailsContainer>
            <LabelTitle>{title}</LabelTitle>
            <div>{message}</div>
          </LabelDetailsContainer>
          <LabelDetailsButtonsContainer>
            <LabelCancelButton
              id="label-cancel"
              aria-label="label-cancel"
              onClick={onLabelDismiss}
            >{cancelTranslation}</LabelCancelButton>
          </LabelDetailsButtonsContainer>
        </LabelDetailsWrapper>
      </PortalContainer>
    }
  />
)